import { StackScreenProps } from "@react-navigation/stack";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SettingsRootParamList } from "../../../../types";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { isValidPositiveMoneyValue } from "../../../../utilities/is-valid-money";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { DynamicMobileText } from "../../../../components/DynamicMobileText";

export interface EditMinLaybySpendScreenProps
  extends StackScreenProps<SettingsRootParamList, "EditMinLaybySpendScreen"> {}

export const EditMinLaybySpendScreen = ({
  navigation,
}: EditMinLaybySpendScreenProps) => {
  const shouldFocus = useHasTransitionEnded(navigation);
  const globalSettings = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();
  const { minLaybySpend } = globalSettings;
  const [value, setValue] = useState(minLaybySpend.toString());

  const isDirty = useMemo(() => {
    return value !== minLaybySpend.toString();
  }, [value, minLaybySpend]);

  const isValid = useMemo(() => {
    return isValidPositiveMoneyValue(value);
  }, [value]);

  const handleOnSave = useCallback(async () => {
    return updateGlobalSettings({
      minLaybySpend: parseInt(value),
    })
      .then((e) => navigation.goBack())
      .catch((err) => console.log(err));
  }, [value]);

  useEffect(() => {
    const disabled = !isDirty || !isValid;
    navigation.setOptions({
      headerTitleAlign: "center",
      headerTitle: () => <DynamicMobileText label="Edit Min Layby Spend" />,

      headerStatusBarHeight: 10,

      headerRight: () => {
        return (
          <Button
            label="Save"
            isAction
            disabled={disabled}
            onPress={handleOnSave}
            size="compact"
          ></Button>
        );
      },
    });
  }, [isValid, handleOnSave, isDirty]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder="Minimum Layby Sale Amount"
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
        formatterType="money"
        validationMessage={
          isValid ? undefined : "Please enter a valid dollar amount"
        }
      />
    </Page>
  );
};
